import {SvgIcon, useTheme} from '@mui/material';

export default function LocationOff() {
	const theme = useTheme();
	// @ts-ignore
	const color = theme.palette.mode === 'light' ? theme.palette.primary[800] : theme.palette.primary.main;
	return (
		<svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g filter="url(#filter0_d_3080_6994)">
				<rect x="12" y="8" width="44" height="44" rx="22" fill="#ffb4ab" shape-rendering="crispEdges"/>
				<path
					d="M34 38.25C32.85 38.25 31.74 38.02 30.7 37.56C30.32 37.39 30.15 36.95 30.31 36.57C30.48 36.19 30.92 36.02 31.3 36.18C32.15 36.55 33.06 36.74 34 36.74C37.72 36.74 40.75 33.71 40.75 29.99C40.75 29.05 40.56 28.14 40.19 27.29C40.02 26.91 40.2 26.47 40.58 26.3C40.96 26.14 41.4 26.31 41.57 26.69C42.03 27.73 42.26 28.84 42.26 29.99C42.25 34.55 38.55 38.25 34 38.25Z"
					fill="#00174C"/>
				<path
					d="M28.58 35.94C28.38 35.94 28.19 35.86 28.04 35.71C26.56 34.16 25.75 32.14 25.75 30C25.75 25.45 29.45 21.75 34 21.75C36.15 21.75 38.18 22.57 39.73 24.06C40.03 24.35 40.04 24.82 39.75 25.12C39.46 25.42 38.99 25.43 38.69 25.14C37.42 23.92 35.76 23.25 34 23.25C30.28 23.25 27.25 26.28 27.25 30C27.25 31.75 27.92 33.41 29.13 34.67C29.42 34.97 29.41 35.44 29.11 35.73C28.96 35.87 28.77 35.94 28.58 35.94Z"
					fill="#00174C"/>
				<path
					d="M34 22.75C33.59 22.75 33.25 22.41 33.25 22V20C33.25 19.59 33.59 19.25 34 19.25C34.41 19.25 34.75 19.59 34.75 20V22C34.75 22.41 34.41 22.75 34 22.75Z"
					fill="#00174C"/>
				<path
					d="M26 30.75H24C23.59 30.75 23.25 30.41 23.25 30C23.25 29.59 23.59 29.25 24 29.25H26C26.41 29.25 26.75 29.59 26.75 30C26.75 30.41 26.41 30.75 26 30.75Z"
					fill="#00174C"/>
				<path
					d="M34 40.75C33.59 40.75 33.25 40.41 33.25 40V38C33.25 37.59 33.59 37.25 34 37.25C34.41 37.25 34.75 37.59 34.75 38V40C34.75 40.41 34.41 40.75 34 40.75Z"
					fill="#00174C"/>
				<path
					d="M44 30.75H42C41.59 30.75 41.25 30.41 41.25 30C41.25 29.59 41.59 29.25 42 29.25H44C44.41 29.25 44.75 29.59 44.75 30C44.75 30.41 44.41 30.75 44 30.75Z"
					fill="#00174C"/>
				<path
					d="M31.88 32.87C31.69 32.87 31.5 32.8 31.35 32.65C30.64 31.94 30.25 31 30.25 30C30.25 27.93 31.93 26.25 34 26.25C35 26.25 35.94 26.64 36.65 27.35C36.94 27.64 36.94 28.12 36.65 28.41L32.41 32.65C32.26 32.8 32.07 32.87 31.88 32.87ZM34 27.75C32.76 27.75 31.75 28.76 31.75 30C31.75 30.34 31.83 30.67 31.97 30.97L34.97 27.97C34.67 27.83 34.34 27.75 34 27.75Z"
					fill="#00174C"/>
				<path
					d="M23.9995 40.7499C23.8095 40.7499 23.6195 40.6799 23.4695 40.5299C23.1795 40.2399 23.1795 39.7599 23.4695 39.4699L43.4695 19.4699C43.7595 19.1799 44.2395 19.1799 44.5295 19.4699C44.8195 19.7599 44.8195 20.2399 44.5295 20.5299L24.5295 40.5299C24.3795 40.6799 24.1895 40.7499 23.9995 40.7499Z"
					fill="#00174C"/>
			</g>
			<defs>
				<filter id="filter0_d_3080_6994" x="0" y="0" width="68" height="68" filterUnits="userSpaceOnUse"
				        color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					               result="hardAlpha"/>
					<feOffset dy="4"/>
					<feGaussianBlur stdDeviation="6"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.160784 0 0 0 0 0.478431 0 0 0 0.1 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3080_6994"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3080_6994" result="shape"/>
				</filter>
			</defs>
		</svg>
	
	);
}
